import React from 'react';
var TabContext = /*#__PURE__*/React.createContext(null);
export default TabContext;